<template>
  <footer id="product-form-footer" class="position-fixed bg-white py-4 border-top" :style="{ 'width': footerWidth }">
    <b-alert
      :show="isConfirmDelete"
      variant="primary"
      class="confirm-delete-product-container position-absolute rounded-0 w-100 border-0 text-white d-flex align-items-center justify-content-between"
      ref="confirm-delete-prompt"
    >
      {{ deleteSpiel }}
      <div class="confirm-delete-actions-container d-inline-flex align-items-center">
        <b-button
          variant="ghost"
          class="cancel-button text-white shadow-none mr-2"
          :disabled="loading"
          @click="isConfirmDelete = false"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          class="save-button px-4 py-2"
          :disabled="loading"
          @click="$root.$emit('proceedDeleteProductInventory')"
        >
          {{ loading ? "Deleting..." : "Yes" }}
        </b-button>
        <div class="spacer"></div>
      </div>
    </b-alert>
    <b-container fluid class="text-right">
      <b-button
        variant="ghost"
        class="btn-cancel px-4 mr-3"
        @click="handleBackButton"
      >
        Cancel
      </b-button>
      <b-button
        variant="ghost"
        class="btn-cancel px-4 mr-3 d-none"
        @click="saveProduct(true)"
      >
        Save as draft
      </b-button>
      <b-button variant="primary" class="px-4" @click="saveProduct()">
        {{ saveButtonLabel }}
      </b-button>
    </b-container>
    <ProductFooterPrompts />
  </footer>
</template>

<script>
import { mapState } from "vuex";
import ProductFooterPrompts from "./ProductFooterPrompts";
import _ from "lodash";
import commonMixins from "@/mixins/common";

export default {
    mixins: [commonMixins],
    props: {
        untouchedForm: [Object, String],
        form: Object
    },
    components: { ProductFooterPrompts },
    data() {
        return {
            popoverShow: false,
            isConfirmDelete: false,
            footerWidth: 0
        };
    },
    computed: {
        ...mapState("estoreInventories", {
            loading: state => state.loading,
            productDetails: state => state.product_data
        }),
        saveButtonLabel() {
            return this.$route.name === "CreateProduct"
                ? "Add Product"
                : "Update Product";
        },
        isTaggedToBranch() {
            if (
                this.productDetails &&
                _.has(this.productDetails, "branch_uuids")
            )
                return this.productDetails.branch_uuids.length > 0;
            else return false;
        },
        deleteSpiel() {
            if (this.isTaggedToBranch)
                return "This product is currently tagged to a branch and brand. Are you sure you want to delete this product?";
            else return "Are you sure you want to remove this product?";
        }
    },
    created() {
        const appContainer = document.getElementById("app-content");

        if (appContainer) this.footerWidth = `${appContainer.clientWidth}px`;

        window.addEventListener("resize", () => {
            setTimeout(() => {
                if (appContainer)
                    this.footerWidth = `${appContainer.clientWidth}px`;
            }, 300);
        });
    },
    mounted() {
        this.$root.$on(
            "setProductInventoryDelete",
            value => (this.isConfirmDelete = value)
        );
        this.$root.$on("cancelProductCreation", () => this.cancel());
        this.repositionBottomActions([document.getElementById("product-form-footer")]);
    },
    beforeDestroy() {
        this.$root.$off("setProductInventoryDelete");
        this.$root.$off("cancelProductCreation");
    },
    methods: {
        handleBackButton() {
            if (this.untouchedForm !== JSON.stringify(this.form)) this.cancel();
            else this.$router.go(-1);
        },
        cancel() {
            if (!this.is_saved) {
                this.$root.$emit("bv::show::modal", "product-creation-prompt", {
                    title: "Leave without saving?",
                    message:
                        "Are you sure you want to cancel the creation of the product?",
                    buttons: [
                        {
                            type: "leave",
                            label: "Leave this page"
                        },
                        {
                            type: "close",
                            label: "Stay on this page",
                            variant: "primary"
                        }
                    ]
                });
            } else this.$router.go(-1);
        },
        saveProduct(draft = false) {
            if (draft) console.log("save as draft");
            else {
                this.$root.$emit("validateProductCreation");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#product-form-footer {
    bottom: 0;
    z-index: 9;
    .btn {
        border-radius: 20px;
    }
    .spacer {
        width: 100px;
    }
}
.confirm-delete-product-container {
    bottom: -16px;
    background: #2f4858;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    z-index: 9;
}
</style>
